import React, { useEffect, useState } from 'react';
import { FiInfo, FiX } from 'react-icons/fi';
import apiService from '../../services/api';
import styles from './DashboardAnnouncement.module.css';

// Sitewide dashboard announcement banner — shown to students and admin in
// the same top-of-dashboard slot as ActiveAttendanceSessions. Admin manages
// the message itself from AnnouncementAdminPanel; this component only reads
// and (optionally) dismisses it. Renders nothing when there's no active
// announcement or the current viewer already dismissed this version.
export default function DashboardAnnouncement() {
  const [announcement, setAnnouncement] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const res = await apiService.getActiveAnnouncement();
        if (!isMounted) return;
        if (res.success && res.announcement) {
          setAnnouncement(res.announcement);
          setDismissed(Boolean(res.dismissed));
        }
      } catch (err) {
        // Non-fatal — the dashboard just renders without the banner.
      } finally {
        if (isMounted) setLoaded(true);
      }
    })();
    return () => { isMounted = false; };
  }, []);

  const handleDismiss = async () => {
    setDismissed(true); // optimistic — a failed dismiss just means it reappears next visit
    try {
      await apiService.dismissAnnouncement(announcement.version);
    } catch (err) {
      // Non-fatal
    }
  };

  if (!loaded || !announcement || dismissed) return null;

  return (
    <div className={styles.card}>
      <div className={styles.body}>
        <p className={styles.title}>
          <FiInfo size={16} className={styles.icon} />
          IMPORTANT ANNOUNCEMENT
        </p>
        <p className={styles.message}>{announcement.message}</p>
      </div>
      <button className={styles.dismiss} onClick={handleDismiss} aria-label="Dismiss announcement" title="Dismiss">
        <FiX size={16} />
      </button>
    </div>
  );
}
